import { LayoutTriggerValueType } from 'defs/layout';
import { GO_TOP, LOCK_BODY, UNLOCK_BODY } from './layout.actionTypes';

export const actionCreators = {
	doLockBody: (triggerComponent?: LayoutTriggerValueType, opts?: Object) => ({
		type: LOCK_BODY,
		triggerComponent,
		opts,
	}),
	doUnlockBody: (triggerComponent?: LayoutTriggerValueType) => ({
		type: UNLOCK_BODY,
		triggerComponent,
	}),
	doGoTop: (id: string, triggerComponent?: LayoutTriggerValueType) => ({
		type: GO_TOP,
		triggerComponent,
		id,
	}),
};

export type LayoutActionType =
	| ReturnType<typeof actionCreators.doLockBody>
	| ReturnType<typeof actionCreators.doUnlockBody>
	| ReturnType<typeof actionCreators.doGoTop>;
